import { NETWORK } from '@/utils/constants'

export const formatSatsPer = (sats: any) => {
	if (!sats) {
		return { sats: 0, per: 'sats' }
	}

	const showSats = sats < 1e7

	if (showSats) {
		const magnitude = Math.max(-Math.floor(Math.log(sats) / Math.log(10) + 1), 0)
		return { sats: parseFloat(sats.toFixed(Math.min(magnitude + 2, 8))), per: 'sats' }
	}

	return { sats: (sats / 1e8).toFixed(2), per: NETWORK }
}
